import PropTypes from 'prop-types'
import React from 'react'

import Button from 'components/common/Button'

import TextInputElement from 'components/forms/TextInputElement'

import { EMAIL_CONTACT_METHOD, PHONE_NUMBER_CONTACT_METHOD } from 'src/services/contact_methods'

import styles from './login-form.scss'
import inputStyles from 'src/styles/inputs.css'

export default class LoginForm extends React.Component {
  state = {
    showErrors: false,
    showContactForm: false
  }

  _setFirstName = (event) => {
    this.props.updateForm({ firstName: event.target.value })
  }

  _setLastName = (event) => {
    this.props.updateForm({ lastName: event.target.value })
  }

  _contactMethodType = () => {
    const { contactMethod } = this.props
    return contactMethod ? contactMethod.type : PHONE_NUMBER_CONTACT_METHOD
  }

  _inputClassName () {
    const { transparent } = this.props
    return transparent ? 'transparent-text-input' : 'text-input'
  }
  _loginFormClassName () {
    const { fields, transparent } = this.props
    const loading = fields.confirmationCodeLoading
    if (loading) {
      return transparent ? 'login-form-loading-transparent' : 'login-form-loading'
    } else {
      return 'login-form'
    }
  }

  _onSubmit = (e) => {
    const { submitForm } = this.props
    e.preventDefault()
    if (this._formIsValid()) {
      submitForm()
    } else {
      this.setState({ showErrors: true })
    }
  }

  _formIsValid () {
    const { fields } = this.props
    const hasFirstName = fields.firstName && fields.firstName !== ''
    return hasFirstName
  }

  _saveFormRef = (ref) => { this._form = ref }

  _renderForm () {
    const { fields } = this.props
    const { showErrors } = this.state
    const inputClassName = this._inputClassName()
    const loginFormStyleName = this._loginFormClassName()

    return (
      <form
        className={styles[loginFormStyleName]}
        onSubmit={this._onSubmit}
        ref={this._saveFormRef}
      >
        <div className={styles['name-fields']}>
          <div className={styles['input-wrapper']}>
            <TextInputElement
              className={inputStyles[inputClassName]}
              onChange={this._setFirstName}
              placeholder='First Name'
              valid={!showErrors || fields.firstName !== ''}
              value={fields.firstName}
            />
            <TextInputElement
              className={inputStyles[inputClassName]}
              placeholder='Last Name'
              value={fields.lastName}
              valid={!showErrors || fields.lastName !== ''}
              onChange={this._setLastName}
            />
          </div>
        </div>
        <Button disabled={!this._formIsValid()} className={styles['button']} onClick={this._onSubmit}>Next</Button>
        <input style={{ display: 'none' }} type='submit' />
      </form>
    )
  }

  render () {
    const { transparent } = this.props
    const confirmationTextClass = transparent ? 'confirmation-text-transparent' : 'confirmation-text'

    return (
      <div className={styles['container']}>
        <div className={styles['login-form-container']}>
          {this._renderForm()}
        </div>
        <p className={styles[confirmationTextClass]}>
          You will receive a confirmation via&nbsp;
          {this._contactMethodType() === EMAIL_CONTACT_METHOD ? 'email' : 'text'}
        </p>
      </div>
    )
  }
}

LoginForm.propTypes = {
  contactMethod: PropTypes.object,
  fields: PropTypes.object,
  updateForm: PropTypes.func.isRequired,
  submitForm: PropTypes.func.isRequired,
  transparent: PropTypes.bool
}



// WEBPACK FOOTER //
// ./src/components/login_form/LoginForm.jsx